// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbs":"e_Ag","shortLine":"e_Bg","splitter":"e_Cg","topBlock":"e_Dg","topAside":"e_Eg","topContent":"e_Fg","contentTitle":"e_Gg","splitter2":"e_Hg","comments":"e_Ig"};